/**
 * PhotoGallery — галерея фотографий инвестпроекта (US-05.2 FR-2.4):
 * ряд превью с горизонтальной прокруткой. Не загрузившиеся изображения
 * скрываются без ошибки интерфейса (НФТ «надёжность»); если не загрузилось
 * ни одно — блок не отображается.
 */
import { useState } from 'react';

interface PhotoGalleryProps {
  photos: string[];
  title: string;
  testId?: string;
}

export const PhotoGallery = ({ photos, title, testId }: PhotoGalleryProps) => {
  const [failed, setFailed] = useState<Set<string>>(new Set());
  const visible = photos.filter((src) => !failed.has(src));
  if (visible.length === 0) return null;

  return (
    <div className="mt-4" data-testid={testId}>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-text-faint">
        {title}
      </p>
      <div className="flex gap-2.5 overflow-x-auto pb-1">
        {visible.map((src) => (
          <img
            key={src}
            src={src}
            alt={title}
            loading="lazy"
            className="h-32 w-48 shrink-0 rounded-lg border border-surface-border object-cover"
            onError={() =>
              setFailed((prev) => new Set(prev).add(src))
            }
          />
        ))}
      </div>
    </div>
  );
};
